import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Button from 'src/components/atoms/button/button';
import { Form, FormError, FormItem, FormRow } from 'src/components/atoms/form';
import Label from 'src/components/atoms/label/label';
import Modal from 'src/components/atoms/modal/modal';
import { Select, TOptionType } from 'src/components/atoms/select/select';
import Spinner from 'src/components/atoms/spinner/spinner';
import { CreateUserBody } from 'src/models/user.model';
import { RootState, useAppDispatch, useAppSelector } from 'src/reducers';
import { getRoles } from 'src/reducers/roles.reducer';
import { rolesDefaultParams } from 'src/utils/pagination-utils';
import { validationSchema } from 'src/utils/validation-utils';
import { createNewUser } from 'src/reducers/user.reducer';
import { SYSTEM_ROLE } from 'src/config/constants';

export const CreateEmployee = () => {
  const dispatch = useAppDispatch();

  const { roles } = useAppSelector((state: RootState) => state.roles);
  const { createLoading } = useAppSelector(state => state.user);

  const defaultNewEmployee: CreateUserBody = {
    email: '',
    roleId: null,
  };

  const authorityOptions: TOptionType[] = roles
    .filter(item => item.role.name !== SYSTEM_ROLE)
    .map(role => {
      return { label: role.role.name, value: role.role.id };
    }) as TOptionType[];

  const {
    register,
    getValues,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { defaultNewEmployee },
  });

  const selectAuthority = data => {
    setValue('defaultNewEmployee.roleId', data.value as number, { shouldValidate: true });
  };

  const values = getValues();

  const sendNewEmployee = () => {
    dispatch(createNewUser(values.defaultNewEmployee));
  };

  useEffect(() => {
    dispatch(getRoles({ pagination: rolesDefaultParams }));
  }, [dispatch]);

  return (
    <>
      <Modal.Header />
      <Modal.Body>
        <Form>
          <FormRow col="2">
            <FormItem>
              <Label>Email</Label>
              <input
                required
                autoComplete="off"
                className={`form-control ${errors.defaultNewEmployee?.email ? 'is-invalid' : ''}`}
                type={'text'}
                placeholder="Email"
                {...register('defaultNewEmployee.email', validationSchema.email)}
              />
              <FormError error={errors?.defaultNewEmployee?.email} validation={validationSchema.email} />
            </FormItem>
            <FormItem>
              <Label>Mansione</Label>
              <Select
                options={authorityOptions}
                onSelect={selectAuthority}
                placeholder="Mansione"
                {...register('defaultNewEmployee.roleId', validationSchema.required)}
              />
              <FormError error={errors?.defaultNewEmployee?.roleId} validation={validationSchema.required} />
            </FormItem>
          </FormRow>
          <FormRow>
            <Button
              color="white"
              size="md"
              rounded="rounded-md"
              mode="outline"
              onClick={sendNewEmployee}
              disabled={!isValid || createLoading}
            >
              {createLoading ? <Spinner /> : 'Crea dipendente'}
            </Button>
          </FormRow>
        </Form>
      </Modal.Body>
    </>
  );
};
